module.exports = __webpack_public_path__ + "img/drug-3.b2099e11.png";